import React, { useState } from 'react';
import { Outlet, NavLink, useLocation } from 'react-router-dom';

// Icons for the sidebar navigation
const NavIcons = {
  Dashboard: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5m.75-9 3-3 2.148 2.148A12.061 12.061 0 0 1 16.5 7.605" />
    </svg>
  ),
  Vault: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
      <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 9m18 0V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v3" />
    </svg>
  ),
  Swap: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
      <path strokeLinecap="round" strokeLinejoin="round" d="M7.5 21 3 16.5m0 0L7.5 12M3 16.5h13.5m0-13.5L21 7.5m0 0L16.5 12M21 7.5H7.5" />
    </svg>
  ),
  Bridge: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
      <path strokeLinecap="round" strokeLinejoin="round" d="M8.288 15.038a5.25 5.25 0 0 1 7.424 0M5.106 11.856c3.807-3.808 9.98-3.808 13.788 0M1.924 8.674c5.565-5.565 14.587-5.565 20.152 0M12.53 18.22l-.53.53-.53-.53a.75.75 0 0 1 1.06 0Z" />
    </svg>
  ),
  Wallet: () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5">
      <path strokeLinecap="round" strokeLinejoin="round" d="M21 12a2.25 2.25 0 0 0-2.25-2.25H15a3 3 0 1 1-6 0H5.25A2.25 2.25 0 0 0 3 12m18 0v6a2.25 2.25 0 0 1-2.25 2.25H5.25A2.25 2.25 0 0 1 3 18v-6m18 0V9M3 12V9m18 0a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 9m18 0V6a2.25 2.25 0 0 0-2.25-2.25H5.25A2.25 2.25 0 0 0 3 6v3" />
    </svg>
  ),
};

// Menu icon for mobile hamburger
const MenuIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
  </svg>
);

// Close icon for mobile menu
const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-6 h-6">
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
  </svg>
);

// Token badge components - smaller for header
const XRPToken = () => (
  <div className="flex items-center">
    <div className="w-6 h-6 rounded-full overflow-hidden ring-1 ring-white/10">
      <img src="/images/XRP.png" alt="XRP" className="w-full h-full object-cover" />
    </div>
  </div>
);

const RLUSDToken = () => (
  <div className="flex items-center">
    <div className="w-6 h-6 rounded-full overflow-hidden ring-1 ring-white/10">
      <img src="/images/RLUSD.png" alt="RLUSD" className="w-full h-full object-cover" />
    </div>
  </div>
);

// Water ripple logo with gradient blue
const RippleOneLogo = () => (
  <div className="relative group">
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="drop-shadow-lg">
      <defs>
        <linearGradient id="rippleGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{stopColor:"#4FC3F7", stopOpacity:1}} />
          <stop offset="50%" style={{stopColor:"#2196F3", stopOpacity:1}} />
          <stop offset="100%" style={{stopColor:"#1976D2", stopOpacity:1}} />
        </linearGradient>
      </defs>
      
      {/* Water Ripple Icon */}
      <g transform="translate(4, 4)">
        {/* Outer ripple */}
        <circle cx="12" cy="12" r="10" fill="none" stroke="url(#rippleGradient)" strokeWidth="1.2" opacity="0.3" className="animate-pulse-slow"/>
        {/* Middle ripple */}
        <circle cx="12" cy="12" r="6.5" fill="none" stroke="url(#rippleGradient)" strokeWidth="1.2" opacity="0.6"/>
        {/* Inner ripple */}
        <circle cx="12" cy="12" r="3.5" fill="none" stroke="url(#rippleGradient)" strokeWidth="1.2" opacity="0.9"/>
        {/* Center drop */}
        <circle cx="12" cy="12" r="1.2" fill="url(#rippleGradient)"/>
      </g>
    </svg>
  </div>
);

// Enhanced header with better typography and spacing
const TokenPairHeader = () => (
  <div className="flex items-center gap-3">
    <XRPToken />
    <RLUSDToken />
    <span className="text-lg font-semibold tracking-wide">XRP / RLUSD</span>
  </div>
);

const MainLayout: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const navItems = [
    { name: 'Dashboard', path: '/app/dashboard', icon: NavIcons.Dashboard },
    { name: 'Vault', path: '/app/vault', icon: NavIcons.Vault },
    { name: 'Swap', path: '/app/swap', icon: NavIcons.Swap },
    { name: 'Bridge', path: '/app/bridge', icon: NavIcons.Bridge },
    { name: 'Wallet', path: '/app/wallet', icon: NavIcons.Wallet },
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <div className="flex min-h-screen mesh-gradient">
      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="fixed inset-0 bg-black/60 z-40 lg:hidden" 
          onClick={closeMobileMenu}
        />
      )}

      {/* Responsive Sidebar */}
      <div className={`
        ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full'} 
        lg:translate-x-0 lg:fixed fixed inset-y-0 left-0 z-50
        w-64 lg:w-64 bg-dark-bg-darker/95 backdrop-blur-xl 
        border-r border-ripple-gray-dark/20 shadow-xl
        transition-transform duration-300 ease-in-out
      `}>
        <div className="p-4 lg:p-5">
          {/* Mobile Close Button */}
          <div className="flex items-center justify-between mb-6 lg:mb-8">
            <div className="flex items-center gap-2 ml-2">
              <RippleOneLogo />
              <div>
                <span className="text-lg font-bold tracking-tight text-white">
                  RippleOne
                </span>
              </div>
            </div>
            
            {/* Close button only visible on mobile */}
            <button
              onClick={closeMobileMenu}
              className="lg:hidden p-2 text-gray-400 hover:text-white transition-colors touch-manipulation"
            >
              <CloseIcon />
            </button>
          </div>

          <nav className="space-y-2 lg:space-y-1.5">
            {navItems.map((item) => (
              <NavLink
                key={item.name}
                to={item.path}
                onClick={closeMobileMenu}
                className={({ isActive }) => 
                  `sidebar-item ${isActive ? 'active pulse-animation' : ''} group relative overflow-hidden
                   min-h-[48px] lg:min-h-0 touch-manipulation`
                }
              >
                <div className="flex items-center gap-3 relative z-10">
                  <div className="p-2 lg:p-1.5 rounded-lg bg-dark-bg-lighter/50 group-hover:bg-ripple-blue/20 transition-all duration-300">
                    <item.icon />
                  </div>
                  <span className="font-medium text-sm lg:text-sm">{item.name}</span>
                </div>
                <div className="absolute inset-0 bg-gradient-to-r from-ripple-blue/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 rounded-xl"></div>
              </NavLink>
            ))}
          </nav>
        </div>
        
        {/* Compact wallet section */}
        <div className="absolute bottom-0 left-0 w-full p-4 lg:p-5">
          <div className="glass flex items-center gap-3 text-ripple-gray-light p-3 rounded-xl hover:shadow-blue-glow transition-all duration-300 border border-white/5 min-h-[60px] lg:min-h-0">
            <div className="w-8 h-8 lg:w-7 lg:h-7 rounded-full overflow-hidden ring-1 ring-white/10 flex-shrink-0">
              <img src="/images/XRP.png" alt="XRP" className="w-full h-full object-cover" />
            </div>
            <div className="min-w-0 flex-1">
              <div className="font-medium text-white text-sm">0 XRP</div>
              <div className="text-xs font-medium tracking-wide truncate">Not connected</div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 lg:ml-64 overflow-auto ripple-container main-content">
        {/* Responsive Top Nav Bar */}
        <div className="h-16 lg:h-16 border-b border-ripple-gray-dark/20 flex items-center justify-between px-4 lg:px-6 xl:px-8 sticky top-0 bg-dark-bg/90 backdrop-blur-xl z-10 shadow-sm">
          <div className="flex items-center gap-4 lg:gap-8">
            {/* Mobile Menu Button */}
            <button
              onClick={toggleMobileMenu}
              className="lg:hidden p-2 text-gray-400 hover:text-white transition-colors touch-manipulation -ml-2"
            >
              <MenuIcon />
            </button>
            
            <h1 className="text-lg lg:text-xl font-bold tracking-tight truncate">
              {navItems.find(item => item.path === location.pathname)?.name || 'Dashboard'}
            </h1>
          </div>
          
          <div className="flex items-center gap-2 lg:gap-4">
            {/* Token Pair Indicator - Hidden on small screens */}
            <div className="hidden sm:flex items-center gap-2 px-2 lg:px-3 py-1.5 bg-gradient-to-br from-slate-800/50 via-blue-900/10 to-slate-900/50 backdrop-blur-xl border border-blue-500/20 rounded-lg">
              <div className="flex items-center gap-1.5">
                <div className="w-4 h-4 lg:w-5 lg:h-5 rounded-full overflow-hidden ring-1 ring-white/10">
                  <img src="/images/XRP.png" alt="XRP" className="w-full h-full object-cover" />
                </div>
                <span className="text-xs font-medium text-white hidden sm:inline">XRP</span>
              </div>
              <span className="text-xs text-slate-400">/</span>
              <div className="flex items-center gap-1.5">
                <div className="w-4 h-4 lg:w-5 lg:h-5 rounded-full overflow-hidden ring-1 ring-white/10">
                  <img src="/images/RLUSD.png" alt="RLUSD" className="w-full h-full object-cover" />
                </div>
                <span className="text-xs font-medium text-white hidden sm:inline">RLUSD</span>
              </div>
            </div>

            {/* Responsive Connect Wallet Button */}
            <button className="bg-gradient-to-r from-blue-500 via-blue-400 to-blue-600 text-white text-xs lg:text-xs font-semibold px-3 lg:px-4 py-2 lg:py-2 rounded-lg shadow-lg shadow-blue-500/30 hover:shadow-blue-500/50 hover:scale-105 transition-all duration-300 border border-blue-400/20 min-h-[40px] lg:min-h-0 touch-manipulation">
              <span className="hidden sm:inline">Connect Wallet</span>
              <span className="sm:hidden">Connect</span>
            </button>
          </div>
        </div>

        {/* Responsive Page Content */}
        <div className="px-4 lg:px-6 xl:px-8 py-4 lg:py-6">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default MainLayout; 